import { ForcePackageData } from '../../../../../types/force-packages';
import { FieldRules, rules, runRules, ValidatedJsonType, ValidationResult } from '../validator';

export function isForcePackageJson(value: ValidatedJsonType): ValidationResult {
	const json = value as ForcePackageData;

	const fields: FieldRules[] = [
		{
			key: 'name',
			actual: json.name,
			rules: [rules.optional(json.name, rules.isString(json.name))],
		},
		{
			key: 'complexity',
			actual: json.complexity,
			rules: [rules.optional(json.complexity, rules.isNumber(json.complexity))],
		},
		{
			key: 'cost',
			actual: json.cost,
			rules: [rules.isString(json.cost), rules.noSpaces(json.cost)],
		},
		{
			key: 'type',
			actual: json.type,
			rules: [rules.optional(json.type, rules.isNumber(json.type))],
		},
		{
			key: 'systems',
			actual: json.systems,
			rules: [
				rules.isObject(json.systems),
				rules.custom(
					'every system must have numeric id, side, string name, string symbol and string|number cost',
					() =>
						typeof json.systems === 'object' &&
						json.systems !== null &&
						Object.values(json.systems).every(
							(s: any) =>
								typeof s.id === 'number' &&
								typeof s.name === 'string' &&
								typeof s.side === 'number' &&
								(typeof s.cost === 'number' || typeof s.cost === 'string') &&
								typeof s.symbol === 'string'
						)
				),
			],
		},
		{
			key: 'fp',
			actual: json.fp,
			rules: [
				rules.isObject(json.fp),
				rules.custom(
					'fp.type must be a number',
					() =>
						typeof json.fp === 'object' &&
						json.fp !== null &&
						typeof (json.fp as any).type === 'number'
				),
				rules.custom(
					'fp.name must be a string',
					() =>
						typeof json.fp === 'object' &&
						json.fp !== null &&
						typeof (json.fp as any).name === 'string'
				),
				rules.custom(
					'fp.echelons must be an array',
					() =>
						typeof json.fp === 'object' &&
						json.fp !== null &&
						Array.isArray((json.fp as any).echelons)
				),
				rules.custom(
					'every echelon must have string name, array echelons, numeric id, valid systems array, boolean is_lego, numeric type, and array|undefined parameters',
					() =>
						typeof json.fp === 'object' &&
						json.fp !== null &&
						Array.isArray((json.fp as any).echelons) &&
						(json.fp as any).echelons.every(
							(echelon: any) =>
								typeof echelon.name === 'string' &&
								Array.isArray(echelon.echelons) &&
								typeof echelon.id === 'number' &&
								Array.isArray(echelon.systems) &&
								echelon.systems.every(
									(s: any) =>
										typeof s.agent_id === 'number' &&
										typeof s.system_id === 'number'
								) &&
								typeof echelon.is_lego === 'boolean' &&
								typeof echelon.type === 'number' &&
								(Array.isArray(echelon.parameters) ||
									echelon.parameters === undefined)
						)
				),
			],
		},
	];

	return runRules(fields);
}

export const validateForcePackage = (data: ValidatedJsonType): ValidationResult => {
	return isForcePackageJson(data);
};
